<template>
  <form>
    <validation-observer v-slot="observer">
      <div class="general-form__group form-group row">
        <label
          class="col-4 col-form-label">色付け</label>
        <div class="col-8">
          <validation-provider
            v-slot="v"
            name="色付け">
            <b-form-input
              v-model="_value.color"
              type="color"
              hide-header />
            <p class="text-primary">
              {{ v.errors[0] }}
            </p>
          </validation-provider>
        </div>
      </div>
      <div class="general-form__group form-group row">
        <label
          class="col-4 col-form-label">並び順</label>
        <div class="col-8">
          <validation-provider
            v-slot="v"
            name="並び順"
            rules="required">
            <b-form-input
              v-model="_value.sortOrder"
              type="number"
              hide-header />
            <p class="text-primary">
              {{ v.errors[0] }}
            </p>
          </validation-provider>
        </div>
      </div>
      <div class="general-form__group form-group row">
        <label
          class="col-4 col-form-label">タイトル</label>
        <div class="col-8">
          <validation-provider
            v-slot="v"
            name="タイトル名"
            rules="required">
            <b-form-input
              v-model="_value.title"
              type="text"
              hide-header />
            <p class="text-primary">
              {{ v.errors[0] }}
            </p>
          </validation-provider>
        </div>
      </div>
      <div class="general-form__group form-group row">
        <label
          class="col-4 col-form-label">詳細</label>
        <div class="col-8">
          <validation-provider
            v-slot="v"
            name="詳細">
            <b-form-textarea
              v-model="_value.detail"
              rows="5"
              hide-header />
            <p class="text-primary">
              {{ v.errors[0] }}
            </p>
          </validation-provider>
        </div>
      </div>
      <div class="general-form__group form-group row">
        <div
          class="col-4">
          <label class="col-form-label">カテゴリー</label>
          <p class="sub-text">
            「なし」の場合はすべての予定表にこのテンプレートを表示します
          </p>
        </div>
        <div class="col-8">
          <validation-provider
            v-slot="v"
            name="詳細">
            <b-form-select
              v-model="_value.category"
              :options="categoryOptions"
              class="mb-3"
              value-field="id"
              text-field="name" />
            <p class="text-primary">
              {{ v.errors[0] }}
            </p>
          </validation-provider>
        </div>
      </div>
      <div class="general-form__btn row mt-5">
        <div class="col-6">
          <button
            type="button"
            class="btn btn-block btn-cancel"
            @click="onClickCancel">
            キャンセル
          </button>
        </div>
        <div class="col-6">
          <button
            type="button"
            class="btn btn-block btn-primary"
            @click="observer.passes(onSubmit)">
            {{ isEdit ? '保存' : '作成' }}
          </button>
        </div>
      </div>
    </validation-observer>
  </form>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('events', ['categories']),
    _value: {
      get() {
        return this.value
      },
      // 親コンポーネントの現在のpropsに書き換える。
      set(v) {
        this.$emit('input', v)
      }
    },
    categoryOptions() {
      return [
        {
          id: null,
          name: 'なし'
        },
        ...this.categories
      ]
    }
  },
  methods: {
    onSubmit(){
      this.$emit('submit')
    },
    onClickCancel(){
      this.$router.push('/admin/templates/')
    }
  }
}
</script>

<style lang="scss" scoped>
.template {
  &__item {
    position: relative;
    background-color: $white;
    border-radius: 8px;
    font-weight: bold;
  }

  &__icon{
    vertical-align: middle;
    display: inline-block;
  }

  &__btn {
    position: relative;
    box-shadow: 1px 2px 6px $grey05;
    padding: 2px;
    line-height: 27px;
    @media screen and (min-width:768px) {
      padding: auto;
      line-height: auto;
    }
  }

  &__btn-icon{
    display: inline-block;
    vertical-align: text-bottom;
    font-size: 20px;
  }
}

.sub-text {
  font-size: $fs-xs;
  margin-right: -15px;
}
</style>